import fetch from 'utils/fetch';

export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS';
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';

function requestProducts() {
  return {
    type: REQUEST_PRODUCTS,
  };
}

function receiveProducts(products) {
  return {
    type: RECEIVE_PRODUCTS,
    payload: {
      products,
    },
  };
}

export function fetchProducts() {
  return dispatch => {
    dispatch(requestProducts());
    fetch('/products.json')
      .then(res => res.json())
      .then(products => dispatch(receiveProducts(products)));
  };
}



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/product.js